var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.item2.name))]),_c('b-row',{attrs:{"tag":"ul"}},_vm._l((_vm.item2.L3),function(item3){return _c('ServiceL3',{key:item3,staticClass:"search-two",attrs:{"item3":item3},on:{"sendWorkingCategoryData":_vm.getWorkingCategoryData}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }